import { observer } from 'mobx-react';
import { useAuthStore } from '../../contexts/mobx';
import { Card, Descriptions } from 'antd';
import moment from 'moment';
import { PageTopBar } from '../../components/page-top-bar';
import style from './style.module.scss';
export const ProfilePage = observer(() => {
    const authStore = useAuthStore();

    const { claims, roles, expireAt, hasManagementAccess } = authStore;

    const timestamp = expireAt ? expireAt : 0;
    const formatted = moment
        .unix(timestamp)
        .format('dddd, MMMM Do, YYYY h:mm:ss A');

    return (
        <>
            <PageTopBar title="Profile" />

            <div className={`content_with_margins ${style.cards_container}`}>
                <Card title="Profile">
                    <Descriptions title={claims?.name}>
                        <Descriptions.Item label="Email">
                            {claims?.email}
                        </Descriptions.Item>
                        <Descriptions.Item label="Roles">
                            {roles.join(', ')}
                        </Descriptions.Item>
                        <Descriptions.Item label="Session expire">
                            {formatted}
                        </Descriptions.Item>
                    </Descriptions>
                </Card>

                {hasManagementAccess && (
                    <Card title="Section Admin">
                        <p>
                            Unlimited access to all sections of the application.
                        </p>
                    </Card>
                )}
            </div>
        </>
    );
});
